import { render, staticRenderFns } from "./SecurityItem.vue?vue&type=template&id=a6b2f6ba&scoped=true"
import script from "./SecurityItem.vue?vue&type=script&lang=js"
export * from "./SecurityItem.vue?vue&type=script&lang=js"
import style0 from "./SecurityItem.vue?vue&type=style&index=0&id=a6b2f6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2f6ba",
  null
  
)

export default component.exports